import axios from 'axios'
import router from './router.js'

// Creating customizable axios singleton instance
const axiosInstance = axios.create()

// Handling invalid jwt token by forceful data removal and routing to login
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401 || error.response.status === 403) {
      window.localStorage.removeItem('vuex')
      router.push({name: 'login'})
    }
    return Promise.reject(error)
  }
)

// Setting token for requests
axiosInstance.interceptors.request.use(
  config => {
    let token
    const persistedStore = JSON.parse(localStorage.getItem('vuex'))
    if (persistedStore && persistedStore.auth && persistedStore.auth.token) {
      token = persistedStore.auth.token
    }

    if (token && !config.url.includes('login') && !config.url.includes('logout')) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default axiosInstance



// WEBPACK FOOTER //
// ./src/commons/gdprcontrol-axios.js